module.exports = __webpack_public_path__ + "img/client.0a49f9f1.jpg";